import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./css/BannerSection.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

// Custom Arrow Components
const NextArrow = ({ onClick }) => (
  <div className="custom-arrow next-arrow" onClick={onClick}>
    <FaChevronRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="custom-arrow prev-arrow" onClick={onClick}>
    <FaChevronLeft />
  </div>
);

const BannerSection = () => {
  const [destination, setDestination] = useState("");
  const [isAutoSuggestVisible, setIsAutoSuggestVisible] = useState(false);
  const [trendingDestinations, setTrendingDestinations] = useState([]);
  const [filteredDestinations, setFilteredDestinations] = useState([]);

  const backgroundImages = [
    "./Images/tour/mini-jone-banner1.jpg",
    "./Images/tour/mini-jone-banner2.jpg",
    "./Images/tour/mini-jone-banner3.jpg",
    "./Images/tour/mini-jone-banner4.jpg",
    "./Images/tour/mini-jone-banner5.jpg",
  ];

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 1500,
    autoplaySpeed: 4000,
    fade: true,
    arrows: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    pauseOnHover: false,
  };

  useEffect(() => {
    const fetchDestinations = async () => {
      try {
        const response = await fetch("https://admin.miniandjone.com/api/HolidayPackages/destinations");
        const result = await response.json();
        if (result.success) {
          setTrendingDestinations(result.data);
        }
      } catch (error) {
        console.error("Error fetching destinations:", error);
      }
    };
    fetchDestinations();
  }, []);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setDestination(value);
    if (value.trim() === "") {
      setFilteredDestinations([]);
      return;
    }
    const filtered = trendingDestinations.filter((dest) =>
      dest.name.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredDestinations(filtered);
    setIsAutoSuggestVisible(true);
  };

  const handleDestinationSelect = (dest) => {
    setDestination(dest.name);
    setIsAutoSuggestVisible(false);
    setFilteredDestinations([]);
    window.location.href = `/${dest.slug}`;
  };

  const handleSearchClick = () => {
    if (destination.trim() === "") return;
    const matched = trendingDestinations.find(
      (dest) => dest.name.toLowerCase() === destination.toLowerCase()
    );
    if (matched) {
      window.location.href = `/${matched.slug}`;
    } else {
      window.location.href = `/${destination.replace(/\s+/g, "-").toLowerCase()}`;
    }
  };

  return (
    <>
      <div className="holiday-banner-slider-wrapper">
        <div className="hero-shape style3">
          <img src="https://html.themeholy.com/tourm/assets/img/hero-shape-3.png" alt="" />
        </div>
        <Slider {...settings} className="background-slider">
          {backgroundImages.map((img, idx) => (
            <div key={idx}>
              <div
                className="holiday-banner"
                style={{
                  backgroundImage: `url('${img}')`,
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  position: "relative", // added for overlay
                }}
              >
                  {/* Black Overlay */}
                  <div className="banner-overlay"></div>
                <Container>
                  {/* Slider Text */}
                  <h2 className="headingbanner">
                    Tour Packages with Mini and Jone
                  </h2>

                  <div className="search_box_prnt" style={{ marginTop: "120px" }}>
                    <div className="search_box_wrapper">
                      <div className="search_box">
                        <img
                          src="https://images.emtcontent.com/holiday-img/home-img/search.svg"
                          alt="holidays"
                        />
                        <input
                          type="text"
                          placeholder="Enter Your Dream Destination!"
                          autoComplete="off"
                          value={destination}
                          onChange={handleInputChange}
                          onFocus={() => {
                            setIsAutoSuggestVisible(true);
                            if (destination.trim() === "") {
                              setFilteredDestinations(trendingDestinations);
                            }
                          }}
                          onBlur={() => setTimeout(() => setIsAutoSuggestVisible(false), 200)}
                        />
                        <button className="subm_btn" type="button" onClick={handleSearchClick}>
                          Search
                        </button>
                      </div>
                    </div>

                    {isAutoSuggestVisible && filteredDestinations.length > 0 && (
                      <div className="auto_sgtn">
                        <div className="d-flex align-items-center" style={{ padding: "10px 15px", gap: "15px" }}>
                          <img
                            src="https://images.emtcontent.com/holiday-img/home-img/cir_loc.svg"
                            alt="location"
                          />
                          <span>
                            <strong>Top Trending</strong> Holiday Destinations
                          </span>
                        </div>
                        <ul className="auto_sgtn_ul">
                          {filteredDestinations.map((dest, index) => (
                            <li key={index} className="d-flex align-items-center" onClick={() => handleDestinationSelect(dest)}>
                              <a className="d-flex align-items-center">
                                <div className="img_box ulimg">
                                  <img
                                    src={dest.image}
                                    alt={dest.name}
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src = "https://images.emtcontent.com/holiday-img/home-img/city-100x.png";
                                    }}
                                  />
                                </div>
                                <div className="cont">
                                  <p>{dest.name}</p>
                                </div>
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                </Container>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
};

export default BannerSection;
